import React from 'react';
import styled from 'styled-components';

const StepContainer = styled.div`
  padding: 2rem;
  text-align: center;
`;

const SuccessIcon = styled.div`
  font-size: 4rem;
  color: #10b981;
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  color: #333;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.4;
`;

const OrderDetailsCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.5rem;
  max-width: 400px;
  margin: 0 auto 2rem;
`;

const OrderDetailsTitle = styled.h3`
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
`;

const OrderDetailsGrid = styled.div`
  display: grid;
  gap: 0.75rem;
  text-align: left;
`;

const OrderDetailRow = styled.div`
  color: #333;
  font-size: 0.95rem;
  
  strong {
    color: #333;
    font-weight: 600;
  }
`;

const ConfirmationText = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin: 0;
  line-height: 1.4;
`;

const OrderConfirmationStep = ({ order, customerInfo }) => {
    return (
        <StepContainer>
            <SuccessIcon>✅</SuccessIcon>
            <Title>Order Confirmed!</Title>
            <Subtitle>
                Thank you for your purchase! Your tickets have been confirmed.
            </Subtitle>

            <OrderDetailsCard>
                <OrderDetailsTitle>Order Details</OrderDetailsTitle>
                <OrderDetailsGrid>
                    <OrderDetailRow>
                        <strong>Order Number:</strong> {order?.orderNumber}
                    </OrderDetailRow>
                    <OrderDetailRow>
                        <strong>Email:</strong> {customerInfo?.email}
                    </OrderDetailRow>
                    <OrderDetailRow>
                        <strong>Total:</strong> ${order?.totalAmount?.toFixed(2)}
                    </OrderDetailRow>
                </OrderDetailsGrid>
            </OrderDetailsCard>

            <ConfirmationText>
                A confirmation email has been sent to {customerInfo?.email}
            </ConfirmationText>
        </StepContainer>
    );
};

export default OrderConfirmationStep;
